/// <amd-module name="Test/TestPlansHubRefresh/TestHub/Utils/TestPlansHubRefreshLocalContextProvider" />
import * as React from "react";
import { ITestHubRefreshLocalContext } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshContracts";

/**
 * TestHubRefreshLocalContext: The react context object that provides a Provider and Consumer for accessing and sharing data.
 * TestHubRefreshConnectedView (root connected component) uses the Provider and any child component can access this data via the Consumer or React.useContext()
 * See ITestHubRefreshLocalContext documentation in code for more details on what kind of data to store.
 */
export const TestHubRefreshLocalContext = React.createContext<ITestHubRefreshLocalContext>({} as ITestHubRefreshLocalContext);

/**
 * testHubRefreshLocalContextData: The actual data you want to share across components
 */
export let testHubRefreshLocalContextData: ITestHubRefreshLocalContext;

export const initializeTestHubLocalContext = (currentPivot: string | undefined) => {
    testHubRefreshLocalContextData = {
        _isPageLoad: true,
        isPageLoad: () => {
            return testHubRefreshLocalContextData._isPageLoad;
        },
        setPageLoad: (val: boolean) => {
            testHubRefreshLocalContextData._isPageLoad = val;
        },

        _currentSelectedPivot: currentPivot,
        getCurrentPivot: () => {
            return testHubRefreshLocalContextData._currentSelectedPivot;
        },
        setCurrentPivot: (val: string) => {
            testHubRefreshLocalContextData._currentSelectedPivot = val;
        },

        _webRunnerPointIds: [],
        getWebRunnerPointIds: () => {
            return testHubRefreshLocalContextData._webRunnerPointIds;
        },
        setWebRunnerPointIds: (Ids: number[]) => {
            testHubRefreshLocalContextData._webRunnerPointIds = Object.assign([], Ids);
        },

        _selectedTestCaseIds: [],
        getSelectedTestCaseIds: () => {
            return testHubRefreshLocalContextData._selectedTestCaseIds;
        },
        setSelectedTestCaseIds: (Ids: number[]) => {
            testHubRefreshLocalContextData._selectedTestCaseIds = Object.assign([], Ids);
        },

        _isJsonIslandDataDirty: false,
        isJsonIslandDataDirty: () => {
            return testHubRefreshLocalContextData._isJsonIslandDataDirty;
        },
        makeJsonIslandDataDirty: () => {
            testHubRefreshLocalContextData._isJsonIslandDataDirty = true;
        },

        _isAuthorFilterActiveOrSet: false,
        isAuthorFilterActiveOrSet: () => {
            return testHubRefreshLocalContextData._isAuthorFilterActiveOrSet;
        },
        setIsAuthorFilterActiveOrSet: (value: boolean) => {
            testHubRefreshLocalContextData._isAuthorFilterActiveOrSet = value;
        },

        _isExecuteFilterActiveOrSet: false,
        isExecuteFilterActiveOrSet: () => {
            return testHubRefreshLocalContextData._isExecuteFilterActiveOrSet;
        },
        setIsExecuteFilterActiveOrSet: (value: boolean) => {
            testHubRefreshLocalContextData._isExecuteFilterActiveOrSet = value;
        }
    };
};
